import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

import useStyles from './styles'
import Navigation from '../../../context/Navigation'

const MainLayout = ({ children, ...navigationProps }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Navigation {...navigationProps} />
      <Box component="main" className={classes.content}>
        <Box component="span" className={classes.spacer} />
        {children}
      </Box>
    </Box>
  )
}

MainLayout.propTypes = {
  children: PropTypes.node,
  userName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onLogout: PropTypes.func,
  isLoggingOut: PropTypes.bool,
}

export default MainLayout
